// Helper functions for VerifyTwoFAForm

export const getDisplayValues = (countDownSeconds: number) => {
  // calculate time left in minutes and seconds, assumes countDownSeconds is >= 0
  const minutes = Math.floor((countDownSeconds % (60 * 60)) / 60);
  const seconds = Math.floor(countDownSeconds % 60);
  return [minutes, seconds];
};
